<script setup lang="ts">
import { useI18n } from "vue-i18n"

import { PRIVACY_POLICY } from "@/pages"

const { t } = useI18n({ useScope: "global" })
</script>

<template>
  <RouterLink id="privacypolicylink-link-privacypolicy" :to="{ name: 'DocumentGet', params: { id: PRIVACY_POLICY } }" class="link" :title="t('footer.privacyPolicy')">{{
    t("footer.privacyPolicyShort")
  }}</RouterLink>
</template>
